import React from "react";
import { Container } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import mockNotifications from "./mockNotifications"; // Import Mock Data ✅
import NotificationsPanel from "./NotificationPanle";
import { jwtDecode } from "jwt-decode";

const NotificationsPage = () => {
  const token = localStorage.getItem("access_token")
  const merchant = jwtDecode(token)

  return (
    <Container fluid>
      {/* ✅ Breadcrumb Navigation */}
      <Breadcrumbs mainTitle="Notifications" parent="Dashboard" title="Notifications" />

      {/* ✅ Notifications Panel (Passing Mock Data) */}
      <NotificationsPanel merchantId={merchant?.merchant} />
    </Container>
  );
};

export default NotificationsPage;
